<template>
    <div class="perfect_wrap">
        <div class="perfect_box" v-if="info.complainEndTime">
            <div class="perfect_title">
                <!-- // supplementType 完善办结信息结果类型：1-自行和解 2-调解成功 3-调解失败 4-启用质保金赔偿 -->
                {{ info.supplementType === 1 ? '自行和解' : info.supplementType === 2 ? '调解成功' : info.supplementType === 3 ? '调解失败' : '启用质保金赔偿' }}
            </div>
            <div class="content2">
                <div class="content_one">
                    <div class="content_left">结案时间</div>
                    <div class="content_right">{{ info.complainEndTime }}</div>
                </div>
                <div class="content_one" v-if="info.supplementType !== 3">
                    <div class="content_left">赔偿金额</div>
                    <div class="content_right">{{ info.amount }}元</div>
                </div>
                <div class="content_one" v-if="info.supplementType === 2">
                    <div class="content_left">履行时间</div>
                    <div class="content_right">{{ info.fulfillTime }}</div>
                </div>
                <div class="content_one" v-if="info.supplementType === 2">
                    <div class="content_left">履行地点</div>
                    <div class="content_right">{{ info.fulfillPlace }}</div>
                </div>
                <div class="content_one" v-if="info.supplementType === 2 || info.supplementType === 4">
                    <div class="content_left">事实经过</div>
                    <div class="content_right">{{ info.realSituation }}</div>
                </div>
                <div class="content_one">
                    <div class="content_left">{{ (info.supplementType === 1 || info.supplementType === 4) ? '和解备注' : '调解备注' }}</div>
                    <div class="content_right">{{ info.supplementType !== 2 ? info.remark : info.agreement }}</div>
                </div>
                
                <div class="content_one">
                    <div class="content_left">完善时间</div>
                    <div class="content_right">{{ info.createTime }}</div>
                </div>
                <div class="content_one">
                    <div class="content_left">完善部门</div>
                    <div class="content_right">{{ info.operateOrgName }}</div>
                </div>
                <div class="content_one">
                    <div class="content_left">完善人员</div>
                    <div class="content_right">{{ info.operateUserName }}</div>
                </div>

                <div class="content_one_img">
                    <div class="content_left">相关附件</div>
                    <materiascience :caseList="info.fileUrl"></materiascience>
                </div>

                <div class="content_one_img content_two">
                    <div class="content_left">相关图片</div>
                    <div class="content_img">
                        <img
                        :src="item"
                        v-for="(item,index) in imgList"
                        :key="index"
                        @click="showViewer(index, $event, imgList)"
                        alt
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!info.complainEndTime" class="noInfo">
            <div class="box1">
                <img src="../../../../assets/empty/ic_wuxingxi.png" />
                <p class="tip1">暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
import materiascience from '../../component/materialScience_show';
import api from '../../../../service/modules/complaintApis';
import util from '@/utils/common';
import isNoInfo from '../../../../components/isNoInfo';

export default {
    components: {
        materiascience,
        isNoInfo
    },
    data () {
        return {
            itemList: util.getJsonLocal('item'),
            imgList: [],
            files: [],
            info: {},
        }
    },
    created () {
        this.getInfo();
    },
    methods: {
        getInfo () {
            let data = {
                data: {
                    type: 'supplementInfo',
                    mainComplainNumber: this.itemList.mainComplainNumber
                }
            }
            api.return.detailsInfo(data).then(res => {
                if (res.ret === 0) {
                    let data = res.data.supplementDetail[0];
                    if (data && data.complainEndTime) {
                        this.info = data;
                    }
                    if (data && data.imgUrl && data.imgUrl.length) {
                        data.imgUrl.forEach(el => {
                            return this.imgList.push(el.url);
                        });
                    }
                    if (data && data.fileUrl && data.fileUrl.length) {
                        for (let i = 0; i < data.fileUrl.length; i++) {
                            let str = data.fileUrl[i].url + '';
                            let fileName = str.substring(str.lastIndexOf('/') + 1, str.lastIndexOf('.'));
                            let fileType = str.substr(str.lastIndexOf('.') + 1);
                            data.fileUrl[i].fileName = fileName;
                            data.fileUrl[i].fileType = fileType;
                        }
                    }
                }
            })
        },
        /**
         *      图片预览
         */
        showViewer (index, event, imgList) {
            this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
        }
    }
}
</script>

<style lang="less" scoped>
.perfect_wrap {
    width: 100%;
    padding: 0px 12px 20px;
    .noInfo {
        margin-top: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        .box1 {
            text-align: center;
            img {
                display: inline-block;
                width: 74px;
                height: 62px;
            }
            .tip1 {
                font-size: 14px;
                color: #9b9b9b;
                margin-top: 24px;
            }
            .tip2 {
                font-size: 14px;
                color: #9b9b9b;
                margin-top: 8px;
            }
        }
    }
    .perfect_box {
        background: #fff;
        padding-left: 14px;
        .perfect_title {
            font-size: 14px;
            font-weight: 600;
            color: #333;
            padding-top: 16px;
        }
        .content2 {
            padding-top: 16px;
            .content_one {
                width: 100%;
                overflow: hidden;
                margin-bottom: 16px;
                .content_left {
                    float: left;
                    color: #999999;
                    font-size: 14px;
                    width: 70px;
                    line-height: 18px;
                    margin-right: 16px;
                }
                .content_right {
                    width: 70%;
                    float: left;
                    color: #333333;
                    line-height: 18px;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    .content_right_parent_content{
                        float: left;
                        color: #36b374;
                    }
                    .content_right_parent_img{
                        float: left;
                        margin-left: 8px;
                        .content_right_img {
                            width: 15px;
                            height: 15px;
                        }
                    }

                }
            }
            .content_file {

            }
            .content_two {
                padding-bottom: 20px;
            }
            .content_one_img {
                width: 100%;
                overflow: hidden;
                margin-bottom: 12px;
                display: flex;
                flex-direction: column;
                .content_left {
                    float: left;
                    color: #999999;
                    font-size: 14px;
                    width: 70px;
                    line-height: 18px;
                    margin-right: 16px;
                }
            }
            
            .content_img {
                width: 100%;
                padding-top: 10px;
                img {
                    float: left;
                    width: 74px;
                    height: 74px;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    border-radius: 3px;
                }
            }
        }
    }
}
</style>
